function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 0h80v80H2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.526 19h54.948C75.287 19 80 23.713 80 29.526V67H4V29.526C4 23.713 8.713 19 14.526 19zm30.36 40.647c4.392 1.153 8.54-.06 9.264-2.708.725-2.65-2.249-5.732-6.641-6.885-4.392-1.153-8.54.059-9.264 2.708-.725 2.649 2.249 5.731 6.641 6.885zm1.394-33.603a1.684 1.684 0 00-2.052 1.185l-3.046 11.14a1.685 1.685 0 001.197 2.073l19.173 5.035a1.684 1.684 0 002.052-1.185l3.046-11.14.004-.016c.236-.9-.302-1.82-1.201-2.057L46.28 26.044zM13.289 33.6l5.355 19.585 13.05-3.428-5.354-19.585L13.289 33.6z",
  fill: "#00ACC1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 66.5h75V29.526c0-5.537-4.489-10.026-10.026-10.026H14.526C8.99 19.5 4.5 23.989 4.5 29.526V66.5zm.553-34.802c6.278 0 11.368-5.051 11.368-11.283m62.737 11.283c-6.279 0-11.369-5.051-11.369-11.283M16.421 66.582c0-6.232-5.09-11.283-11.368-11.283M67.79 66.582c0-6.232 5.09-11.283 11.368-11.283M29.895 19.358V15.68c0-2.032 1.885-3.679 4.21-3.679h16.421c2.326 0 4.21 1.647 4.21 3.68v3.678",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.559 33.922l5.206 19.284 12.525-3.331-5.206-19.284-12.525 3.331z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  transform: "rotate(15 46.504 55.03)",
  cx: 46.504,
  cy: 55.03,
  rx: 8.5,
  ry: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.39 25.963a1.184 1.184 0 00-1.447.835L40.66 38.955v.005c-.169.632.207 1.28.84 1.449l20.881 5.554a1.184 1.184 0 001.448-.836L67.11 32.97l.001-.004a1.184 1.184 0 00-.84-1.45L45.39 25.964z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.053 39.582c2.854 1.75 4.678 4.814 5.473 9.194m-7.579 1.672l10.91-3.11M21.18 40c-.431-1.934.228-3.188 1.978-3.761M19.4 42.858c-.43-1.934.228-3.188 1.978-3.761m-.746.777c-1.153-1.392-3.522-.48-3.361.544m3.782-.836c.971-1.31 2.094-1.594 3.368-.848m-4.215.43c.071-1.39-.629-2.086-2.1-2.09",
  stroke: "#371447",
  strokeWidth: 1.091
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.44 53l1.459 2.252 3.764-1.96 1.819 3.622 2.298-1.18 1.115 3.537c-2.6.977-5.171 1.095-7.714.354-2.542-.741-4.602-2.179-6.181-4.313L42.44 53zm2.845-17.524c.494.201 2.535.73 6.122 1.589l3.575 5.218 1.045.248-.669-4.508c1.903.38 3.183.626 3.841.74.658.112 1.257-.053 1.798-.498l2.298-2.912c-.333-.074-.603-.101-.809-.08-.206.02-1.201.573-2.986 1.658l-3.569-.86 2.669-3.522c-.552-.205-.953-.277-1.204-.217-.252.06-2.027.946-5.327 2.656l-5.16-1.223c-.207-.074-.534-.023-.983.156-.448.178-.785.39-1.01.636-.248.411-.125.717.37.919z",
  fill: "#371447"
}));

function SvgVacationLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVacationLg;